import { defaultLoader } from "@ui/components/media/Image";

export const MEDIA_BASE_URL =
  "https://platform.sbnation.com/wp-content/uploads/sites/2/team-logos";

const TEAM_SLUG_OVERRIDES: Record<string, string> = {
  "sbnation(product)": "sbnation",
  nfl: "sbnation",
  nba: "sbnation",
  marchmadness: "sbnation",
  mlb: "sbnation",
  nhl: "sbnation",
  collegefootball: "sbnation",
  collegebasketball: "sbnation",
  f1: "sbnation",
  soccer: "sbnation",
  // One-level lookup: these names resolve to logo-nhl/nba/nfl/soccer.png and
  // do not chain through the league-feed sbnation overrides above.
  sabrescommunity: "nhl",
  redwingscommunity: "nhl",
  floridapantherscommunity: "nhl",
  canadienscommunity: "nhl",
  senatorscommunity: "nhl",
  lightningcommunity: "nhl",
  mapleleafscommunity: "nhl",
  bluejacketscommunity: "nhl",
  nyrangerscommunity: "nhl",
  flyerscommunity: "nhl",
  capitalscommunity: "nhl",
  blackhawkscommunity: "nhl",
  starscommunity: "nhl",
  wildcommunity: "nhl",
  predatorscommunity: "nhl",
  bluescommunity: "nhl",
  mammothcommunity: "nhl",
  winnipegjetscommunity: "nhl",
  anaheimduckscommunity: "nhl",
  flamescommunity: "nhl",
  lakingscommunity: "nhl",
  sharkscommunity: "nhl",
  krakencommunity: "nhl",
  canuckscommunity: "nhl",
  goldenknightscommunity: "nhl",
  hornetscommunity: "nba",
  bullscommunity: "nba",
  nuggetscommunity: "nba",
  pacerscommunity: "nba",
  grizzliescommunity: "nba",
  heatcommunity: "nba",
  pelicanscommunity: "nba",
  thundercommunity: "nba",
  sacramentokingscommunity: "nba",
  psgcommunity: "soccer",
  vivathematadors: "nfl",
  ourdailybears: "nfl",
  smucommunity: "nfl",
  seattlenbaexpansioncommunity: "nba",
  lvnbaexpansioncommunity: "nba",
};

export function hasTeamLogoOverride(communityName: string): boolean {
  const teamSlug = communityName.replace(/\s+/g, "").toLowerCase();
  const override = TEAM_SLUG_OVERRIDES[teamSlug];
  return typeof override === "string" && override !== "sbnation";
}

export function getTeamLogoUrl({
  communityCanonicalDomain,
  width,
}: {
  communityCanonicalDomain: string;
  width: number;
}): string {
  let teamSlug =
    communityCanonicalDomain.split(".")[0] === "www"
      ? communityCanonicalDomain.split(".")[1]
      : communityCanonicalDomain.split(".")[0];

  if (teamSlug && teamSlug in TEAM_SLUG_OVERRIDES) {
    teamSlug = TEAM_SLUG_OVERRIDES[teamSlug];
  }

  return defaultLoader({
    src: `${MEDIA_BASE_URL}/logo-${teamSlug}.png`,
    width,
  });
}

export const cleanCommunityLogo = (logo: string): string => {
  // Remove single quotes and ampersands everywhere
  let cleaned = logo.replace(/['&]/g, "");
  // Remove dashes only if they appear after "logo-"
  cleaned = cleaned.replace(
    /(logo-)([^/]*)/g,
    (match: string, p1: string, p2: string) => p1 + p2.replace(/-/g, ""),
  );
  return cleaned;
};

export function getTeamLogoUrlByCommunityName({
  communityName,
  width,
}: {
  communityName: string;
  width: number;
}): string {
  let teamSlug = communityName.replace(/\s+/g, "").toLowerCase();

  if (teamSlug in TEAM_SLUG_OVERRIDES) {
    teamSlug = TEAM_SLUG_OVERRIDES[teamSlug] as string;
  }

  const logo = defaultLoader({
    src: `${MEDIA_BASE_URL}/logo-${teamSlug}.png`,
    width,
  });

  return cleanCommunityLogo(logo);
}
